if (!customElements.get('default-tabs')) {
  class DefaultTabs extends HTMLElement {
    static selectors = {
      linksWrapper: '[js-tabs-links-wrapper]',
      link: '[js-tab-link]',
      tab: '[js-tab-item]',
      active: '.is-active',
    };

    static attributes = {
      link: 'js-tab-link',
    };
    static ACTIVE_CLASS = 'is-active';

    constructor() {
      super();
    }

    /**
     * Handles a click event on the tabs link wrapper element.
     * - Finds the clicked tab link element and its corresponding tab content element/s.
     * - Removes the active class from all currently active tab links and tab content elements.
     * - Adds the active class to the clicked tab link and its corresponding tab content elements.
     * - Prevents the default link behavior to allow for client-side tab switching.
     *
     * @param {Event} event - The click event object.
     */
    handleClick(event) {
      const target = event.target.closest('a');
      if (!target || !target.hasAttribute(DefaultTabs.attributes.link)) return;

      const targetHref = target.getAttribute('href');
      const targetTabs = this.querySelectorAll(targetHref);

      if (!targetTabs) return;

      event.preventDefault();

      this.querySelectorAll(DefaultTabs.selectors.active).forEach((el) =>
        el.classList.remove(DefaultTabs.ACTIVE_CLASS),
      );

      target.classList.add(DefaultTabs.ACTIVE_CLASS);
      this.querySelectorAll(`[href="${targetHref}"]`).forEach((element) => {
        element.classList.add(DefaultTabs.ACTIVE_CLASS);
      });
      targetTabs.forEach((tab) => tab.classList.add(DefaultTabs.ACTIVE_CLASS));
    }

    connectedCallback() {
      this.linksWrapper = this.querySelector(
        DefaultTabs.selectors.linksWrapper,
      );

      this.linksWrapper.addEventListener('click', this.handleClick.bind(this));
    }
  }

  customElements.define('default-tabs', DefaultTabs);
}
